import { useLocation } from 'preact-iso'
import { THEME_COLORS } from '../constants/theme'

export function NotFound() {
  const location = useLocation()

  const handleGoHome = () => {
    // Try to go to root, which will redirect properly through RootRedirect
    location.route('/')
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* 404 Number */}
        <div className="mb-8">
          <h1
            className="text-9xl font-bold mb-4"
            style={{ color: THEME_COLORS.GREEN[500] }}
          >
            404
          </h1>
          <div className="h-1 w-24 mx-auto rounded-full" style={{ backgroundColor: THEME_COLORS.GREEN[500] }}></div>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mb-2">
            Page Not Found
          </h2>
          <p className="text-slate-600 dark:text-slate-300 mb-4">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Current path: <code className="bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded text-xs">{location.url}</code>
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleGoHome}
            className="w-full px-6 py-3 text-white font-semibold rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            style={{
              backgroundColor: THEME_COLORS.GREEN[600]
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = THEME_COLORS.GREEN[500]
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = THEME_COLORS.GREEN[600]
            }}
          >
            Go to Dashboard
          </button>

          <button
            onClick={() => window.history.back()}
            className="w-full px-6 py-3 text-slate-600 dark:text-slate-300 border border-slate-300 dark:border-slate-600 font-semibold rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors duration-200"
          >
            Go Back
          </button>
        </div>

        {/* Help Text */}
        <div className="mt-8 text-xs text-slate-400 dark:text-slate-500">
          <p>If you believe this is an error, please contact support.</p>
        </div>
      </div>
    </div>
  )
}
